'use client';
import { atom } from 'jotai';

export const usernameRegistrationStepAtom = atom<{
	suggestions: Array<string>;
}>({
	suggestions: []
});
